import TransferBetweenStoresTable from "./TransferBetweenStoresTable";

const sendData = {

  mode: "add", // edit
  date: "",
  seriesId: "",
  tableData: [
    // {seriesId: "", storeId: "", storeName: "", productId: "", number: "", recordId: ""},
    // {seriesId: "", storeId: "", storeName: "", productId: "", number: "", recordId: ""},
  ]
};
const componentData = {
  currentStoreId: "",
  currentStoreName: "",
  destinationStoreId: "",
  destinationStoreName: "",
}
export const TransferBetweenStoresData = {
  sendData,
  componentData,

}